<template>
  <div class="ratio">
    <el-dialog :visible.sync="show" width="50%" center>
      <h2 slot="title">权重设置</h2>
      <table
        width="100%"
        border="1"
        cellspacing="0"
        cellpadding="10"
        align="center"
        class="table"
      >
        <tr class="head">
          <td>项目</td>
          <td>学生权重</td>
          <td>教师权重</td>
          <td>企业导师权重</td>
          <td>分项权重合计</td>
          <td>总成绩(权重)</td>
        </tr>
        <tr>
          <td class="label">账号定位</td>
          <td>
            <el-input-number
              class="input-number"
              size="mini"
              v-model="ratioInfo.dwStudent"
              :min="0"
              :max="100"
              :controls="false"
            ></el-input-number
            >%
          </td>
          <td>
            <el-input-number
              class="input-number"
              size="mini"
              v-model="ratioInfo.dwTeacher"
              :min="0"
              :max="100"
              :controls="false"
            ></el-input-number
            >%
          </td>
          <td>
            <el-input-number
              class="input-number"
              size="mini"
              v-model="ratioInfo.dwEnterprise"
              :min="0"
              :max="100"
              :controls="false"
            ></el-input-number
            >%
          </td>
          <td class="total">{{ dwTotal }}%</td>
          <td>
            <el-input-number
              class="input-number"
              size="mini"
              v-model="ratioInfo.dwRatio"
              :min="0"
              :max="100"
              :controls="false"
            ></el-input-number
            >%
          </td>
        </tr>
        <tr>
          <td class="label">账号搭建</td>
          <td>
            <el-input-number
              class="input-number"
              size="mini"
              v-model="ratioInfo.djStudent"
              :min="0"
              :max="100"
              :controls="false"
            ></el-input-number
            >%
          </td>
          <td>
            <el-input-number
              class="input-number"
              size="mini"
              v-model="ratioInfo.djTeacher"
              :min="0"
              :max="100"
              :controls="false"
            ></el-input-number
            >%
          </td>
          <td>
            <el-input-number
              class="input-number"
              size="mini"
              v-model="ratioInfo.djEnterprise"
              :min="0"
              :max="100"
              :controls="false"
            ></el-input-number
            >%
          </td>
          <td class="total">{{ djTotal }}%</td>
          <td>
            <el-input-number
              class="input-number"
              size="mini"
              v-model="ratioInfo.djRatio"
              :min="0"
              :max="100"
              :controls="false"
            ></el-input-number
            >%
          </td>
        </tr>
        <tr>
          <td class="label">文案创作</td>
          <td>
            <el-input-number
              class="input-number"
              size="mini"
              v-model="ratioInfo.waStudent"
              :min="0"
              :max="100"
              :controls="false"
            ></el-input-number
            >%
          </td>
          <td>
            <el-input-number
              class="input-number"
              size="mini"
              v-model="ratioInfo.waTeacher"
              :min="0"
              :max="100"
              :controls="false"
            ></el-input-number
            >%
          </td>
          <td>
            <el-input-number
              class="input-number"
              size="mini"
              v-model="ratioInfo.waEnterprise"
              :min="0"
              :max="100"
              :controls="false"
            ></el-input-number
            >%
          </td>
          <td class="total">{{ waTotal }}%</td>
          <td>
            <el-input-number
              class="input-number"
              size="mini"
              v-model="ratioInfo.waRatio"
              :min="0"
              :max="100"
              :controls="false"
            ></el-input-number
            >%
          </td>
        </tr>
        <tr>
          <td class="label">脚本创作</td>
          <td>
            <el-input-number
              class="input-number"
              size="mini"
              v-model="ratioInfo.jbStudent"
              :min="0"
              :max="100"
              :controls="false"
            ></el-input-number
            >%
          </td>
          <td>
            <el-input-number
              class="input-number"
              size="mini"
              v-model="ratioInfo.jbTeacher"
              :min="0"
              :max="100"
              :controls="false"
            ></el-input-number
            >%
          </td>
          <td>
            <el-input-number
              class="input-number"
              size="mini"
              v-model="ratioInfo.jbEnterprise"
              :min="0"
              :max="100"
              :controls="false"
            ></el-input-number
            >%
          </td>
          <td class="total">{{ jbTotal }}%</td>
          <td>
            <el-input-number
              class="input-number"
              size="mini"
              v-model="ratioInfo.jbRatio"
              :min="0"
              :max="100"
              :controls="false"
            ></el-input-number
            >%
          </td>
        </tr>
        <tr>
          <td class="label">视频拍摄</td>
          <td>
            <el-input-number
              class="input-number"
              size="mini"
              v-model="ratioInfo.psStudent"
              :min="0"
              :max="100"
              :controls="false"
            ></el-input-number
            >%
          </td>
          <td>
            <el-input-number
              class="input-number"
              size="mini"
              v-model="ratioInfo.psTeacher"
              :min="0"
              :max="100"
              :controls="false"
            ></el-input-number
            >%
          </td>
          <td>
            <el-input-number
              class="input-number"
              size="mini"
              v-model="ratioInfo.psEnterprise"
              :min="0"
              :max="100"
              :controls="false"
            ></el-input-number
            >%
          </td>
          <td class="total">{{ psTotal }}%</td>
          <td>
            <el-input-number
              class="input-number"
              size="mini"
              v-model="ratioInfo.psRatio"
              :min="0"
              :max="100"
              :controls="false"
            ></el-input-number
            >%
          </td>
        </tr>
        <tr>
          <td class="label">视频剪辑</td>
          <td>
            <el-input-number
              class="input-number"
              size="mini"
              v-model="ratioInfo.jjStudent"
              :min="0"
              :max="100"
              :controls="false"
            ></el-input-number
            >%
          </td>
          <td>
            <el-input-number
              class="input-number"
              size="mini"
              v-model="ratioInfo.jjTeacher"
              :min="0"
              :max="100"
              :controls="false"
            ></el-input-number
            >%
          </td>
          <td>
            <el-input-number
              class="input-number"
              size="mini"
              v-model="ratioInfo.jjEnterprise"
              :min="0"
              :max="100"
              :controls="false"
            ></el-input-number
            >%
          </td>
          <td class="total">{{ jjTotal }}%</td>
          <td>
            <el-input-number
              class="input-number"
              size="mini"
              v-model="ratioInfo.jjRatio"
              :min="0"
              :max="100"
              :controls="false"
            ></el-input-number
            >%
          </td>
        </tr>
        <tr>
          <td class="label">账号运营</td>
          <td colspan="4">
            <p>
              系统计算：分项分值 = 分项数据 / 分项最高值 ; 总分 = 分项分值总和
            </p>
            <p style="color: #909399">分项分值 = 100 / 项数</p>
            <p style="color: #909399">
              分项数据：播放量、评论量、转发量、下载量、点赞量、分享量
            </p>
          </td>
          <td>
            <el-input-number
              class="input-number"
              size="mini"
              v-model="ratioInfo.yyRatio"
              :min="0"
              :max="100"
              :controls="false"
            ></el-input-number
            >%
          </td>
        </tr>
        <tr>
          <td class="label">成果路演</td>
          <td>
            <el-input-number
              class="input-number"
              size="mini"
              v-model="ratioInfo.lyStudent"
              :min="0"
              :max="100"
              :controls="false"
            ></el-input-number
            >%
          </td>
          <td>
            <el-input-number
              class="input-number"
              size="mini"
              v-model="ratioInfo.lyTeacher"
              :min="0"
              :max="100"
              :controls="false"
            ></el-input-number
            >%
          </td>
          <td>
            <el-input-number
              class="input-number"
              size="mini"
              v-model="ratioInfo.lyEnterprise"
              :min="0"
              :max="100"
              :controls="false"
            ></el-input-number
            >%
          </td>
          <td class="total">{{ lyTotal }}%</td>
          <td>
            <el-input-number
              class="input-number"
              size="mini"
              v-model="ratioInfo.lyRatio"
              :min="0"
              :max="100"
              :controls="false"
            ></el-input-number
            >%
          </td>
        </tr>
        <tr>
          <td colspan="5" class="label">总成绩</td>
          <td class="total">{{ totalRatio }}%</td>
        </tr>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="show = false">取 消</el-button>
        <el-button type="primary" size="small" @click="handleSubmit"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getRatio, editRatio } from "@/api/projectPractice/items";
export default {
  data() {
    return {
      show: false,
      ratioInfo: {},
    };
  },
  watch: {
    show(val) {
      if (val) this.getRatioInfo();
    },
  },
  computed: {
    totalRatio() {
      return (
        this.ratioInfo.dwRatio +
        this.ratioInfo.djRatio +
        this.ratioInfo.waRatio +
        this.ratioInfo.jbRatio +
        this.ratioInfo.psRatio +
        this.ratioInfo.jjRatio +
        this.ratioInfo.yyRatio +
        this.ratioInfo.lyRatio
      );
    },
    dwTotal() {
      return (
        this.ratioInfo.dwStudent +
        this.ratioInfo.dwTeacher +
        this.ratioInfo.dwEnterprise
      );
    },
    djTotal() {
      return (
        this.ratioInfo.djStudent +
        this.ratioInfo.djTeacher +
        this.ratioInfo.djEnterprise
      );
    },
    waTotal() {
      return (
        this.ratioInfo.waStudent +
        this.ratioInfo.waTeacher +
        this.ratioInfo.waEnterprise
      );
    },
    jbTotal() {
      return (
        this.ratioInfo.jbStudent +
        this.ratioInfo.jbTeacher +
        this.ratioInfo.jbEnterprise
      );
    },
    psTotal() {
      return (
        this.ratioInfo.psStudent +
        this.ratioInfo.psTeacher +
        this.ratioInfo.psEnterprise
      );
    },
    jjTotal() {
      return (
        this.ratioInfo.jjStudent +
        this.ratioInfo.jjTeacher +
        this.ratioInfo.jjEnterprise
      );
    },
    lyTotal() {
      return (
        this.ratioInfo.lyStudent +
        this.ratioInfo.lyTeacher +
        this.ratioInfo.lyEnterprise
      );
    },
  },
  methods: {
    getRatioInfo() {
      this.$loading.show();
      getRatio(this.$route.query.id).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.ratioInfo = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleCheck() {
      if (this.totalRatio != 100) {
        this.$message.warning("各项目成绩权重总和不等于100");
        return false;
      } else if (this.dwTotal != 100) {
        this.$message.warning("账号定位学生、教师、企业导师权重总和不等于100");
        return false;
      } else if (this.djTotal != 100) {
        this.$message.warning("账号搭建学生、教师、企业导师权重总和不等于100");
        return false;
      } else if (this.waTotal != 100) {
        this.$message.warning("文案创作学生、教师、企业导师权重总和不等于100");
        return false;
      } else if (this.jbTotal != 100) {
        this.$message.warning("脚本创作学生、教师、企业导师权重总和不等于100");
        return false;
      } else if (this.psTotal != 100) {
        this.$message.warning("视频拍摄学生、教师、企业导师权重总和不等于100");
        return false;
      } else if (this.jjTotal != 100) {
        this.$message.warning("视频剪辑学生、教师、企业导师权重总和不等于100");
        return false;
      } else if (this.lyTotal != 100) {
        this.$message.warning("成果路演学生、教师、企业导师权重总和不等于100");
        return false;
      } else return true;
    },
    handleSubmit() {
      if (!this.handleCheck()) return;
      this.$confirm("确定要提交修改吗?", {
        type: "warning",
      })
        .then(() => {
          this.ratioInfo.classId = this.$route.query.id;
          this.$loading.show();
          editRatio(this.ratioInfo).then((res) => {
            this.$loading.hide();
            if (res.code == 0) {
              this.show = false;
              this.$message.success("修改成功");
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
.ratio {
  .table {
    border-color: #f2f6fc;
    td {
      text-align: center;
    }
    .head {
      background: #f5f5f5;
      font-weight: bold;
    }
    .label {
      font-weight: bold;
    }
    .input-number {
      margin-right: 5px;
      width: 60px;
    }
    .total {
      color: #f56c6c;
    }
  }
}
</style>